module.exports = {
  ACCESS_TYPES: Object.freeze({
    STUDENT: "student",
    TUTOR: "tutor",
    ADMIN: "administrator",
    NONE: "none"
  }),

  DB_COLLECTIONS: Object.freeze({
    COURSE: "courses",
    COURSE_RELATIONSHIP: "courseRelationships",
    QUESTION: "questions",
    RESOURCE: "resources",
    RESOURCE_FILES: "resources.files",
    TAG: "tags",
    USER_RECORD: "accounts",
    USER_ACCESS_RECORD: "userAccessRecords"
  }),

  COURSE_GENERAL: Object.freeze({
    ID: "general",
    NAME: "General"
  }),

  COURSE_IDS: Object.freeze({
    SAT: "SAT",
    ACT: "ACT"
  }),

  EMAIL: Object.freeze({
    KEY:
      "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",
    RESET_PASSWORD: "d-3d23c099aba34e61b4c4430601e72c1f",
    CREATE_ACCOUNT: "d-3817a422310542749d09f9765c277ed4"
  }),

  QUESTION_TYPES: Object.freeze({
    GENERAL: "general",
    BOOK: "book",
    EXAM: "exam"
  })
};
